import { useEffect } from 'react';
import { useAnalytics, useScriptLoad } from './hooks';

export function FueledAmazonScript({ withKey: amazonTagId }) {
  const { register } = useAnalytics();
  const { status } = useScriptLoad(
    {
      id: 'fueled-amazon-script',
      innerHTML: `
        !function(w,d,s,t,a){if(w.amzn)return;w.amzn=a=function(){w.amzn.q.push([arguments,(new Date).getTime()])};a.q=[];a.version="0.0";s=d.createElement("script");s.src="https://c.amazon-adsystem.com/aat/amzn.js";s.id="amzn-pixel";s.async=true;t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t)}(window,document);
        amzn("setRegion", "NA");
        amzn("addTag", "${amazonTagId}");
      `,
      waitFor: () => !!window?.amzn,
    },
    'head'
  );

  const ready = register('fueled-amazon-script');

  useEffect(() => {
    if (status !== 'ready') return;

    const pageVisitListener = () => {
      window?.amzn('trackEvent', 'PageView');
    };

    const signUpListener = () => {
      window?.amzn('trackEvent', 'Signup');
    };

    const contactListener = () => {
      window?.amzn('trackEvent', 'Contact');
    };

    const subscribeListener = () => {
      window?.amzn('trackEvent', 'Subscribe');
    };

    const viewSearchResultsListener = (event) => {
      const searchTerm = event?.detail?.ecommerce?.actionField?.search_term;

      if (searchTerm) {
        window?.amzn('trackEvent', 'Search');
      }
    };

    const leadListener = () => {
      window?.amzn('trackEvent', 'Lead');
    };

    window.addEventListener('dl_route_update', pageVisitListener);
    window.addEventListener('dl_sign_up', signUpListener);
    window.addEventListener('dl_subscribe', contactListener);
    window.addEventListener('dl_subscribe', subscribeListener);
    window.addEventListener(
      'dl_view_search_results',
      viewSearchResultsListener
    );
    window.addEventListener('dl_subscribe', leadListener);

    ready();

    return () => {
      window.removeEventListener('dl_route_update', pageVisitListener);
      window.removeEventListener('dl_sign_up', signUpListener);
      window.removeEventListener('dl_subscribe', contactListener);
      window.removeEventListener('dl_subscribe', subscribeListener);
      window.removeEventListener(
        'dl_view_search_results',
        viewSearchResultsListener
      );
      window.removeEventListener('dl_subscribe', leadListener);
    };
  }, [status]);

  return null;
}
